<template>
  <main class="ps" dir="rtl">
    <header class="ps-head"><div><span class="ps-eyebrow">مدیریت پروژه</span><h1>تنظیمات</h1><p>شهرهای تحت پوشش و منوهای پنل را برای پروژه انتخاب‌شده مدیریت کنید.</p></div></header>
    <p v-if="loading" role="status">در حال دریافت تنظیمات…</p>
    <div v-if="error" class="ps-error" role="alert">{{ error }} <button type="button" @click="load">تلاش مجدد</button></div>
    <div v-if="settings && !failed" class="ps-cards">
      <router-link v-if="settings.can_cities" class="ps-card ps-card-link" to="/settings/cities"><span class="ps-card-symbol" aria-hidden="true">⌖</span><h2>تنظیمات شهر</h2><p>انتخاب استان، فعال‌سازی شهرها و افزودن شهر به فهرست.</p><span class="ps-link">مدیریت شهرها ←</span></router-link>
      <router-link v-if="settings.can_menus" class="ps-card ps-card-link" to="/settings/menus"><span class="ps-card-symbol" aria-hidden="true">☷</span><h2>تنظیمات منوهای ادمین</h2><p>تغییر عنوان، ترتیب، گروه‌بندی و نمایش منوها برای هر نقش.</p><span class="ps-link">مدیریت منوها ←</span></router-link>
      <p v-if="!settings.can_cities && !settings.can_menus">برای ویرایش این تنظیمات، به دسترسی مدیر تنظیمات نیاز دارید.</p>
    </div>
    <section class="ps-card"><h2>تنظیمات عملیاتی</h2><p>قواعد اولویت و فرم‌ساز خدمات از زیرمنوهای همین بخش در دسترس هستند.</p></section>
  </main>
</template>
<script>
import { settingsPage } from '../../utils/projectSettings';
import '../../assets/project-settings.css';
export default { mixins: [settingsPage], settingsResource: 'overview', methods: { accept() {} } };
</script>
